import React, { useEffect, useState, useRef } from "react";
import { Eye } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import OpenLayerSource from "../GisManagement/OpenLayerSource";
import Draw from "ol/interaction/Draw";
import "ol/ol.css";
import "./MainRTincidentDashboard.css";
import { IncidentDashboard } from "../../../Components/IconComponents";
import { FaMap, FaMapMarked } from "react-icons/fa";

const MainRTIncidentDashboard = () => {
  const navigate = useNavigate();
  const center = { lat: 25.747554, lng: 85.562257 };
  const zoom = 8;

  const [map, setMap] = useState(null);
  const [source, setSource] = useState(null);
  const [draw, setDraw] = useState(null);

  const setMapInstance = (mapInstance, sourceInstance) => {
    setMap(mapInstance);
    setSource(sourceInstance);
  };

  const drawInteraction = (option) => {
    if (option !== "None" && map && source) {
      let drawInst = new Draw({
        source: source,
        type: option,
      });

      map.addInteraction(drawInst);
      setDraw(drawInst);

      drawInst.on("drawend", (event) => {
        event.stopPropagation();
        event.preventDefault();
        map.removeInteraction(drawInst);
      });
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          className="card-title"
          style={{
            color: "#2A6591",
            textAlign: "left",
            marginLeft: "10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FaMapMarked style={{ position: "relative", top: "-4px" }} />{" "}
          {/* Moves icon up */}
          <span>Active Incident</span>
        </div>

        <div>
          <Eye
            size={20}
            onClick={() => navigate("/dmsdashboard/incidentdashboard")}
            style={{ color: "#2A6591", cursor: "pointer", marginTop: "5px" }}
          />
        </div>
      </div>

      {/* Map Container */}
      <div style={{ width: "100%", height: "500px", marginTop: "5px" }}>
        <OpenLayerSource
          zoom={zoom}
          center={center}
          onmapload={setMapInstance}
        />
      </div>
    </>
  );
};

export default MainRTIncidentDashboard;
